module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "usg_realizado.2cbff95d.png";